module.exports = __webpack_public_path__ + "img/light1.d5030283.png";